export default {"src":"https://s.sylndr.com/c-960f75c/_next/static/media/faqBanner.b2568d82.svg","height":262,"width":1347,"blurWidth":0,"blurHeight":0};